import PropTypes from 'prop-types'
import { cn } from '../../_utils/cn'

/**
 * @param {Object} props
 * @param {boolean} [props.isOpen]
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 */
export const MenuArrow = ({ isOpen, className, style }) => {
  return (
    <span
      data-open={isOpen}
      className={cn('absolute h-3 w-6 pointer-events-none text-tertiary-100', className)}
      style={style}
      aria-hidden="true"
    >
      <svg
        width="24"
        height="12"
        viewBox="0 0 24 12"
        fill="#FFFFFF"
        className="absolute left-1/2 bottom-full block -translate-x-1/2 overflow-hidden"
        style={{
          filter: 'drop-shadow(0 -8px 4px rgba(0,0,0,0.05)) drop-shadow(0 -1px 3px rgba(0,0,0,0.08))',
        }}
      >
        <path d="M0 12 L12 0 L24 12 Z" />
      </svg>
    </span>
  )
}

MenuArrow.propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}
